var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.filterHeaders,
          items: _vm.duckEggCollectionIndexList,
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage,
          "server-items-length": _vm.duckEggCollectionIndexGetCount,
          loading: _vm.duckEggCollectionIndexGetting,
          dense: ""
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item.revenue_source_id",
            fn: function({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    attrs: { color: "yellow darken-3" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("edit", item)
                      }
                    }
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c("span", [_vm._v(_vm._s(item.revenue_source.code))])
              ]
            }
          },
          {
            key: "item.date",
            fn: function({ value }) {
              return [_c("span", [_vm._v(_vm._s(value.dateFormat()))])]
            }
          },
          {
            key: "item.order_id",
            fn: function({ item }) {
              return [
                item.invoice
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          link: "",
                          text: "",
                          color: "primary",
                          small: "",
                          block: "",
                          to: `/orders/${item.order_id}/show`
                        }
                      },
                      [_vm._v(_vm._s(item.invoice.dr_number))]
                    )
                  : _c(
                      "v-btn",
                      {
                        attrs: {
                          text: "",
                          color: "blue-grey",
                          small: "",
                          block: "",
                          loading: _vm.generateDrPosting
                        },
                        on: {
                          click: function($event) {
                            return _vm.generateDr(item.id)
                          }
                        }
                      },
                      [_vm._v("Generate DR")]
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }